<mat-dialog-content>
  <div class="close-wrapper">
    <button
      mat-icon-button
      type="button"
      (click)="close()"
      [attr.aria-label]="'COMMON.ACTION.CLOSE' | translate"
      data-cy="close">
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </div>
  @if (data.titleTranslated || data.titleToTranslate) {
    <div class="title-wrapper">
      @if (data.titleTranslated) {
        <h2 class="title">{{ data.titleTranslated }}</h2>
      }
      @if (data.titleToTranslate) {
        <h2 class="title">{{ data.titleToTranslate | translate }}</h2>
      }
    </div>
  }
  <div class="text-wrapper">
    @if (!data.confirmationTranslated && !data.confirmationToTranslate) {
      <p class="text">
        {{ 'COMMON.CONFIRMATION.ARE_YOU_SURE' | translate }}
      </p>
    }
    @if (data.confirmationTranslated) {
      <p class="text">
        <span [innerHTML]="data.confirmationTranslated | linebreaks"></span>
      </p>
    }
    @if (data.confirmationToTranslate) {
      <p class="text">
        <span innerHTML="{{ data.confirmationToTranslate | translate: data.translateParams }}"></span>
      </p>
    }
  </div>

  @if (data.additionalMessage) {
    <div class="additional-message-wrapper">
      <mat-form-field>
        <input data-cy="additional-message" matInput [(ngModel)]="additionalMessage" />
      </mat-form-field>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions>
  <div class="action-buttons">
    <button mat-raised-button class="cancel-button" (click)="close()">
      {{ (data.noButtonKey ? data.noButtonKey : 'COMMON.ACTION.CANCEL') | translate }}
    </button>
    <button
      mat-raised-button
      class="confirm-button"
      color="primary"
      [disabled]="data.additionalMessage && !additionalMessage.length"
      (click)="save()">
      @if (data.yesButtonIcon) {
        <mat-icon aria-hidden="true">{{ data.yesButtonIcon }}</mat-icon>
      }
      {{ (data.yesButtonKey ? data.yesButtonKey : 'COMMON.GENERAL.YES') | translate }}
    </button>
  </div>
</mat-dialog-actions>
